// extracted by mini-css-extract-plugin
module.exports = {"container":"Article_container__uirXc","columns":"Article_columns__cWXus","image":"Article_image__6pem1"};